import ReconnectingWebSocket from 'reconnecting-websocket';
import type { Options as WebSocketOptions } from 'reconnecting-websocket';
import { WebSocket as WS } from 'ws';

interface WSConnectionCallbacks {
  onConnect?: () => void;
  onHandshake?: (event: MessageEvent) => void;
  onMessage: (event: MessageEvent, ws: ReconnectingWebSocket) => void;
  onDisconnect?: () => void;
  onOffline?: () => void;
}

export const createWebsocketConnection = async (cb: WSConnectionCallbacks, opts?: WebSocketOptions) => {
  const options: WebSocketOptions = {
    WebSocket: WS,
    maxRetries: 5,
    connectionTimeout: 1000,
    reconnectionDelayGrowFactor: 2,
    ...opts
  };

  const res = await fetch('/api/ws-auth');
  const { token } = await res.json().catch(() => console.log('Failed to parse /api/ws-auth response'));

  if (!token) {
    return;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const url = `${protocol}//${window.location.host}/websocket?token=${token}`;

  let ws = new ReconnectingWebSocket(url, [], options);

  ws.addEventListener('open', () => {
    if (ws.retryCount === options.maxRetries) {
      return;
    }

    if (cb.onConnect && ws.readyState === ws.OPEN) {
      cb.onConnect();
    }
  });

  ws.addEventListener('close', (event) => {
    let shouldTerminate = false;

    if (ws.retryCount === options.maxRetries) {
      shouldTerminate = true;
    } else if (event.reason === 'Unauthorized') {
      shouldTerminate = true;
    }

    if (shouldTerminate) {
      ws.close(1001);

      if (cb.onOffline) {
        cb.onOffline();
      }

      return;
    }

    if (cb.onDisconnect) {
      cb.onDisconnect();
    }
  });

  ws.addEventListener('message', (event) => {
    cb.onMessage(event, ws);
  });

  return ws;
};
